import React from 'react'
import PropTypes from 'prop-types'
import {Flex, Stack, Text} from '@salesforce/retail-react-app/app/components/shared/ui'

import {usePromoCode} from '@salesforce/retail-react-app/app/components/promo-code'
import {useTranslationHelpers} from '@epmc-mach/accelarator/overrides/app/hooks'
import Button from '/overrides/app/components/button'

const AppliedPromos = ({basket}) => {
    const {removePromoCode} = usePromoCode()
    const {tCart} = useTranslationHelpers()

    if (!basket.couponItems?.length) {
        return null
    }

    return (
        <Stack p={4} border="1px solid" borderColor="gray.100" borderRadius="base" bg="white">
            <Text fontWeight="medium" fontSize="md">
                {tCart?.promotionApplied} :
            </Text>
            <Stack>
                {basket.couponItems.map((item) => (
                    <Flex key={item.couponItemId} alignItems="center">
                        <Text flex="1" fontSize="sm" color="gray.800">
                            {item.code}
                        </Text>
                        {!basket.orderNo && (
                            <Button
                                variant="link"
                                size="sm"
                                colorScheme="red"
                                onClick={() => removePromoCode(item.couponItemId)}
                            >
                                {tCart?.removePromotions}
                            </Button>
                        )}
                    </Flex>
                ))}
            </Stack>
        </Stack>
    )
}

AppliedPromos.propTypes = {
    basket: PropTypes.object.isRequired,
    fontSize: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl'])
}

export default AppliedPromos
